<app-navigation-layout [hideHeader]='true'>
  <span main-container>
    <app-event-configurator #eventConfigurator></app-event-configurator>
  </span>
  <span menu-container>
    <app-booking-basket-simple-view></app-booking-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBackwardClick()" (forwardClick)="onForwardClick()"
      [forwardError]="forwardError"></app-backward-forward>
  </span>
</app-navigation-layout>
